module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Advanced Settings")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "pt-4 fs-large dark bold"
  }, [_vm._v("\n                Select the information you want to be visible to your customers.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "row py-4"
  }, [_c('div', {
    staticClass: "col-sm-4 d-flex align-items-center py-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.getSelectedWidgetCategory.isToShowDuration),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedWidgetCategory, "isToShowDuration", $$v)
      },
      expression: "getSelectedWidgetCategory.isToShowDuration"
    }
  }), _vm._v("\n                    Show Duration\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex align-items-center py-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.getSelectedWidgetCategory.isToShowTotalAvailability),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedWidgetCategory, "isToShowTotalAvailability", $$v)
      },
      expression: "getSelectedWidgetCategory.isToShowTotalAvailability"
    }
  }), _vm._v("\n                    Show total availability\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex align-items-center py-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.getSelectedWidgetCategory.isToShowActivityName),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedWidgetCategory, "isToShowActivityName", $$v)
      },
      expression: "getSelectedWidgetCategory.isToShowActivityName"
    }
  }), _vm._v("\n                    Show Activity Name\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex align-items-center py-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.getSelectedWidgetCategory.isToShowResourceName),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedWidgetCategory, "isToShowResourceName", $$v)
      },
      expression: "getSelectedWidgetCategory.isToShowResourceName"
    }
  }), _vm._v("\n                    Show resource name\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex align-items-center py-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.getSelectedWidgetCategory.isToShowGroupScheduleTitle),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedWidgetCategory, "isToShowGroupScheduleTitle", $$v)
      },
      expression: "getSelectedWidgetCategory.isToShowGroupScheduleTitle"
    }
  }), _vm._v("\n                    Show schedule title\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex align-items-center py-2"
  }, [_c('checkbox', {
    model: {
      value: (_vm.getSelectedWidgetCategory.isToShowPriceRange),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedWidgetCategory, "isToShowPriceRange", $$v)
      },
      expression: "getSelectedWidgetCategory.isToShowPriceRange"
    }
  }), _vm._v("\n                    Show Price Range\n                ")], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-all",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bef4262"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/WidgetAdvanced.vue
// module id = 1955
// module chunks = 0